import _ from 'lodash';
import localeConfig from 'app-locale';

const nameConfig = localeConfig.name;

function _append(sb, fieldId, value) {
    if (!_.isEmpty(value) && _.includes(nameConfig.visibleFields, fieldId)) {
        sb.push(value);
    }
}

function _format(person, delimiter) {
    const lastName = person.lastNameKanji || person.lastName;
    const firstName = person.firstNameKanji || person.firstName;
    const result = [];
    switch (nameConfig.formatMode) {
        case 'default':
            _append(result, 'FirstName', firstName);
            _append(result, 'LastName', lastName);

            break;
        case 'France':
            _append(result, 'LastName', lastName);
            _append(result, 'FirstName', firstName);
            break;

        case 'Japan':
            _append(result, 'LastName', lastName);
            _append(result, 'FirstName', firstName);
            break;
        default:
            break;
    }
    return result.join(delimiter);
}

export default {
    'getDisplayName': (person, delimiter) => {
        return _format(person, delimiter);
    }
};
